import React, { Component } from 'react';
import { clearDomain, searchDomains, selectDomain } from '../../common/actions/domain-selector-action-creators';

import DomainSelector from '../../common/components/domain-selector';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectedDomainSelector } from '../../reports/selectors/reports-selectors';

export class DomainSelectorContainer extends Component{
    handleDomainSearch = ( params ) => {
        return this.props.searchDomains( params );
    };

    handleDomainSelect = ( domain ) => {
        return this.props.selectDomain( {
            domain,
            namespace: this.props.namespace,
        } );
    };

    handleDomainClear = () => {
        return this.props.clearDomain( {
            namespace: this.props.namespace
        } );
    };

    render(){
        const { selectedDomain, namespace } = this.props;
        return (
            <DomainSelector
                automationId={`domain-selector-${namespace}`}
                handleDomainSearch={this.handleDomainSearch}
                handleDomainSelect={this.handleDomainSelect}
                handleDomainClear={this.handleDomainClear}
                selectedDomain={selectedDomain}
                matchPos="start"
            />
        );
    }
};

DomainSelectorContainer.propTypes = {
    clearDomain: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    searchDomains: PropTypes.func.isRequired,
    selectDomain: PropTypes.func.isRequired,
    selectedDomain: PropTypes.string.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        selectedDomain: selectedDomainSelector( state )
    };
};

export default connect( mapStateToProps, { clearDomain, searchDomains, selectDomain } )( DomainSelectorContainer );
